import React from 'react'

import Input from 'Components/Input'
import Constants from 'EurestoFonction/Constants'
import Grid from '@material-ui/core/Grid'
import Title from 'Components/Title'

export default React.memo(props => <Title inline={props.inline} title={props.title}>
        <Grid container style={{margin: 0, padding: 0}} spacing={0} justify={'center'} alignItems={'center'}>
          <Grid item xs={11} style={{margin: 0, padding: 0}}>
            <Input style={props.style} inline={props.inline}
              onChange={props.onChangeSaisieLibreBool}
              name={'text'}
              disabled={props.disabled || false}
              value={props.data !== undefined && props.data.text !== undefined ? props.data.text : ""}
            />
          </Grid>
          <Grid item xs={1} style={{margin: 0, padding: 0}}>
              <button type="button" onClick={props.onClickBoolSaisieLibreBool}
                      disabled={props.disabled || false}
                      className={'fa fa-' + (props.data !== undefined && (props.data.valeur_bool === true || props.data.valeur_bool === 1 || parseInt(props.data.valeur_bool) === 1) ? 'check-circle-o text-success' : 'times-circle-o text-danger')}
              />
          </Grid>
        </Grid>
      </Title>)


// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataComponent/Components/SaisieLibreBool.js